module.exports = __webpack_public_path__ + "img/CM-BS-25-CJDR-Modern.74027a92.jpg";